import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import axios from "./http";
import store from './store';
import echarts from 'echarts'; //引入echarts
Vue.prototype.$echarts = echarts; //引入组件
//import qs from 'qs';

Vue.prototype.$http = axios;
//Vue.prototype.$qs = qs;

Vue.config.productionTip = false;

//ui 框架
import Vant from 'vant';
import 'vant/lib/index.css';
// import myCharts from './views/reports/myCharts.js'
// Vue.use(myCharts)
Vue.use(Vant);

var isIpad = navigator.userAgent.indexOf('iPad') > -1; //ipad终端
var size = 10;
if (isIpad) size = 15;
// global css
import './styles/index.less';
document.documentElement.style.fontSize = document.documentElement.clientWidth / size + "px";
window.onresize = function() {
	document.documentElement.style.fontSize = document.documentElement.clientWidth / size + "px";
};

var frequency = 1;
var locationResult = {};
window.onload = function() {
	//getFrequency();

};

/* 轨迹频率查询 */
async function getFrequency() {
	var result = await Vue.prototype.$http.get("/FrameWeb/FrameService/Api/FrequencyServer");
	if (result.Trackfrequency == undefined) {
		frequency = 1;
	} else {
		frequency = parseInt(result.Trackfrequency);
	}
	//定时执行，发送定位给后台
	setInterval(() => {
		var user = JSON.parse(localStorage.getItem('user'));
		if (user != null && isWorkTime()) {
			// 请求app定位
			var u = navigator.userAgent;
			var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端 
			var isIPhone = u.indexOf('iPhone') > -1; //iPhone终端
			var isIpad = u.indexOf('iPad') > -1; //ipad终端
			if (isAndroid) {
				locationResult = JSON.parse(window.mobileSale.getCurrentLocation());
			}
			if (isIPhone || isIpad) {
				locationResult = JSON.parse(window.getCurrentLocation());
			}
			if (locationResult != '{}') sendTrackfrequency(user);
		}
	}, frequency * 60000);
};
/* 发送定位 */
async function sendTrackfrequency(userInfo) {
	var data = await Vue.prototype.$http.post(
		"/FrameWeb/getCustomerResult/Api/SignInOrTrajectory", {
			_param: {
				Type: 2,
				OrgID: userInfo.job.JobOrgID,
				userName: userInfo.username,
				Longitude: locationResult.longitude,
				Latitude: locationResult.latitude,
				Address: locationResult.address
			}
		}
	);
};
/* 判断是否是工作时间 */
function isWorkTime() {
	var d = new Date();
	var xq = d.getDay(),
		h = d.getHours(),
		m = d.getMinutes(),
		sj = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
	return (xq >= 1 && xq <= 5 && sj >= '08:00' && sj <= '17:00');
};

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount("#app");
